import styled from 'styled-components';

import {
  Flex,
  utils,
} from 'web-styled';

export const Body = styled(Flex).attrs({
  column: true,
  fillSpace: true,
  spacing: 17,
})`
  width: calc(100% + 25px);
  max-height: 300px;
  margin-right: -30px;
  overflow-x: hidden;
  overflow-y: auto;
`;

interface ItemProps {
  bottomLine: boolean
}

export const Item = styled(Flex).attrs({
  shrink: 0,
  spacing: 20,
})<ItemProps>`
  margin: 0;
  width: 100%;
  position: relative;

  &:before,
  &:after {
    content: '';
    display: none;
    position: absolute;
    left: 11px;
    width: 3px;
    height: 100%;
    ${utils.exerciseColor};

    @media print {
      dislay: none;
    }
  }

  ${props => props.bottomLine && `
    &:after {
      display: block;
      top: 20px;
      @media print {
        display: none;
      }
    }
  `};
`;

export const ItemBody = styled(Flex).attrs({
  column: true,
  spacing: 11,
  grow: 1,
})`
  padding-bottom: 17px;
  border-bottom: 0.5px solid #c7c7cb;

  & > div {
    padding-right: 25px;
  }
`;

export const NumberContainer = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
  clickable: true,
})`
  color: #fff;
  text-transform: uppercase;
  width: 26px;
  height: 26px;
  border-radius: 50%;

  ${utils.exerciseColor};
`;
